var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1068,
    height: 565,
    viewBox: "0 0 1068 565",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896.94 122.255L811.41 125.018L727.005 135.379L772.021 98.0806L832.793 73.215L815.912 38.6795L741.635 22.7933L666.234 10.3606L588.582 0L509.804 0.690541H425.399L342.12 8.28838L264.468 27.6284L310.609 66.9987L363.503 102.225L413.02 138.142L349.998 109.823L274.596 91.1735L194.693 88.4107L115.916 104.297L49.517 134.688L45.0158 172.677L138.424 180.275L228.455 196.161L311.735 217.573L237.458 227.934L159.806 236.913L81.0286 242.439L0 245.892L52.8937 291.479L106.913 335.684L160.931 379.199L220.577 420.642L282.474 460.703L348.873 498.001L419.772 532.537L494.048 565L516.556 518.722L543.566 474.517L570.576 431.002L650.479 444.817L732.632 455.177L814.786 461.394L898.066 467.61L981.345 471.754H1063.5L1065.75 412.353V353.643V294.242V234.841V175.44L1068 116.039H980.219L896.94 122.255Z",
    fill: "#B4B5E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.a8b2a22e891516389a92eeba88e78d9b.svg";
export { ForwardRef as ReactComponent };